import React, { useEffect, useState } from "react";

import { useFormik, Form, Field, Formik } from "formik";
import { number, string } from "yup";
import LeadManageFilters from "./LeadManageFilters";
import NewAxiosInstance from "../../api/api";
import { obj2url } from "../../utils/utils";
import toast from "react-hot-toast";
import { store } from "../../store/store";
import { getDispositionList } from "../../store/actions/tempActions";
import CampaignDetailForm from "./campaignDetailForm";

export interface MyFormValues {
  filter: LeadFilter;
  name: string;
  type: string;
  startDate: string;
  endDate: string;
  total: number;
  assigneeId: number | null;
  remarks: string;
}
export interface LeadFilter {
  roles: string | null;
  source: string | null;
  status: string | null;
  leadType: string | null;
  fromDate: string | null;
  toDate: string | null;
  dispositionId: number | null;
  subDispositionId: number | null;
  name: string | null;
  email: string | null;
  policyNumber: string | null;
  phoneNumber: string | null;
}

export default function LeadManagementPage() {
  const [leadCount, setLeadCount] = useState<number>(0);
  const initialValues: MyFormValues = {
    type: "NORMAL",
    name: "",
    startDate: "",
    endDate: "",
    remarks: "",
    total: 0,
    assigneeId: null,
    filter: {
      roles: null, //
      source: null, //
      status: null, //
      leadType: null, //
      fromDate: null,
      toDate: null,
      dispositionId: null,
      subDispositionId: null,
      name: null,
      email: null,
      policyNumber: null,
      phoneNumber: null,
    },
  };

  return (
    
      <div className="overflow-y-scroll	mb-4">
        <Formik
          initialValues={initialValues}
          onSubmit={(values, actions) => {
            // alert(JSON.stringify(values, null, 2));
            // actions.setSubmitting(false);
          }}
        >
          {(formikProps) => (
            <>
              {/* {console.log(formikProps)}{" "} */}
              <Form>
                <div className="bg-[#E1E3EF]   rounded-md p-5  flex items-start gap-3">
                  <div className="flex gap-8   items-center  w-[100%]  flex-wrap">
                    <LeadManageFilters />

                    <div className="w-full flex  justify-between items-center">
                      <div className="text-lg">Lead Count: {leadCount}</div>
                      <div className="">
                        {" "}
                        {/* <button
                      onClick={() => {
                        formikProps.resetForm();
                      }}
                      className="bg-primary-dark px-4 py-2 rounded-md text-white text-[1.1rem] font-[500] ml-5 w-[150px]"
                      // type="submit"
                    >
                      Reset
                    </button> */}
                        <button
                          className="bg-white px-4 py-2 rounded-md text-primary-dark text-[1.1rem] font-[500] w-[150px]"
                          onClick={() => {
                            NewAxiosInstance()
                              .get(
                                "/crm/campaign/lead/count?" +
                                  obj2url(formikProps.values.filter)
                              )
                              .then((data) => {
                                setLeadCount(data.data.count);
                                toast.success("Lead Count Updated", {
                                  duration: 3000,
                                });
                              })
                              .catch((error) => {
                                toast.error(error?.response?.data?.message, {
                                  duration: 3000,
                                });
                              });
                          }}
                        >
                          Filter
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <CampaignDetailForm />
                <button
                  onClick={async () => {
                    await NewAxiosInstance()
                      .post("/crm/campaign", formikProps.values)
                      .then(async (response) => {
                        console.log(response);
                        if (formikProps.values.type === "NORMAL") {
                          await NewAxiosInstance()
                            .get(
                              `crm/campaign/export/leads?campaignId=${response.data.data.campaignId}`
                            )
                            .then((response) => {
                              response.data.SignedUrl &&
                                window.open(response.data.SignedUrl, "_blank");
                              toast.success("Campaign Created Successfully");
                            })
                            .catch((error) => {
                              toast.error(error?.response?.data?.message, {
                                duration: 3000,
                              });
                            });
                        } else {
                          toast.success("Campaign Created Successfully");
                        }
                      })
                      .catch((error) => {
                        toast.error(error?.response?.data?.message, {
                          duration: 3000,
                        });
                      });
                  }}
                  className="bg-primary-dark px-4 py-2 rounded-md text-white text-[1.1rem] font-[500] ml-5 w-[150px]"
                  // type="submit"
                >
                  Create Campaign
                </button>
              </Form>
            </>
          )}
        </Formik>
      </div>
    
  );
}
